module.exports = __webpack_public_path__ + "static/media/testingImg.8df25513.jpg";